//imports
import {
    ACTIVITIES_TAB_SEARCH_REQUEST,
    ACTIVITIES_TAB_SEARCH_RESULT,
    ACTIVITIES_TAB_SEARCH_USERS_REQUEST,
    ACTIVITIES_TAB_SEARCH_USERS_RESULT,
    ACTIVITIES_TAB_SEARCH_OPEN_MODAL,
    ACTIVITIES_TAB_SEARCH_CLOSE_MODAL,
} from 'Redux/actionTypes';

export const activitiesSearchDataRequest = (filters, entity, instanceId) => ({
    type: ACTIVITIES_TAB_SEARCH_REQUEST,
    payload: { filters, entity, instanceId },
});

export const activitiesSearchDataResult = (result) => ({
    type: ACTIVITIES_TAB_SEARCH_RESULT,
    payload: result
});

export const activitiesSearchUsersTabRequest = (filters, entity, companyName) => ({
    type: ACTIVITIES_TAB_SEARCH_USERS_REQUEST,
    payload: { filters, entity, companyName },
});

export const activitiesSearchUsersTabResult = (result) => ({
    type: ACTIVITIES_TAB_SEARCH_USERS_RESULT,
    payload: result
});

export const activitiesSearchOpenModal = (data, instanceId, companyId) => ({
    type: ACTIVITIES_TAB_SEARCH_OPEN_MODAL,
    payload: { data, instanceId, companyId }
});

export const activitiesSearchCloseModal = () => ({
    type: ACTIVITIES_TAB_SEARCH_CLOSE_MODAL
});